import type { CapturedNetworkRequest } from "posthog-js";

/** API paths whose request and response bodies carry the family's answers
 * or contact details: the quote flow, the forms gateway, the lead
 * submission, and every sign-in, login-grant and auth request. */
const MASKED_BODY_PATHS = /\/api\/v1\/(quotes|leads|auth)\/|\/forms\/v2\//;

/** Whether session replay must drop the bodies of a request to this URL. */
function hasMaskedBodies(url: string): boolean {
  return MASKED_BODY_PATHS.test(url);
}

/** Replay's network-capture hook: URL, status and timing stay, the bodies
 * of the paths above never leave the browser. */
export function maskCapturedNetworkRequest(
  request: CapturedNetworkRequest,
): CapturedNetworkRequest {
  if (hasMaskedBodies(request.name)) {
    request.requestBody = null;
    request.responseBody = null;
  }
  return request;
}
